module.exports = __webpack_public_path__ + "static/media/hostplatform-small-logo.22770090.png";